module.exports = __webpack_public_path__ + "static/bebas-335b1e2a76fa8b7e974f0dc2d12a5cba.woff2";